<template>
  <div>
    <v-card class="mt-2">
      <v-card-title>
        <span class="text-subtitle-1">Recurring Services</span>
        <v-spacer />
        <span>
          <div class="d-flex">
            <v-tooltip top v-if="!isAccountNotActive">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-1"
                  icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="newRecurringServiceClick"
                >
                  <v-icon :color="feature.recurringServices.color">
                    {{ feature.recurringServices.icon }}
                  </v-icon>
                </v-btn>
              </template>
              <span>
                Create new Recurring Service
              </span>
            </v-tooltip>
          </div>
        </span>
      </v-card-title>
      <v-card-text>
        <RecurringServiceSummaryCard
          v-for="rs in cardData.RecurringServiceList"
          :key="rs.RecurringServiceId"
          :rs="rs"
          @editRecurringService="editRecurringServiceEvent"
        />
      </v-card-text>
    </v-card>

    <v-dialog
      persistent
      v-model="showRecurringServiceEditorDialog"
      :width="feature.services.dialogWidth"
    >
      <RecurringServiceEditor
        :isDialogOpen="showRecurringServiceEditorDialog"
        :siteId="cardData.SiteId"
        :recurringServiceId="selectedRecurringServiceId"
        @close="recurringServiceEditorCloseEvent"
        @update="recurringServiceEditorUpdateEvent"
        @editRecurringService="editRecurringServiceEvent"
      />
    </v-dialog>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue2-helpers/vue-router'
import { feature } from '@/use/Constants'
import RecurringServiceEditor from '@/components/ScheduledService/RecurringServiceEditor'
import RecurringServiceSummaryCard from '@/components/ScheduledService/RecurringServiceSummaryCard'
export default {
  name: 'RecurringServicesCard',
  props: {
    cardData: { type: Object, required: true },
    isAccountNotActive: {
      type: Boolean,
      default: false
    }
  },
  components: {
    RecurringServiceEditor,
    RecurringServiceSummaryCard
  },
  setup(props, context) {
    const router = useRouter()
    const showRecurringServiceEditorDialog = ref(false)
    const selectedRecurringServiceId = ref()

    const navigateToServiceSearch = () => {
      router.push({
        name: feature.services.routerName,
        params: {
          siteId: props.cardData.SiteId,
          siteDescription: props.cardData.Description
        }
      })
    }

    const newRecurringServiceClick = () => {
      selectedRecurringServiceId.value = null
      showRecurringServiceEditorDialog.value = true
    }

    const recurringServiceEditorCloseEvent = () => {
      showRecurringServiceEditorDialog.value = false
    }

    const recurringServiceEditorUpdateEvent = () => {
      showRecurringServiceEditorDialog.value = false
      context.emit('update')
    }

    const editRecurringServiceEvent = id => {
      selectedRecurringServiceId.value = id
      showRecurringServiceEditorDialog.value = true
    }

    return {
      feature,
      navigateToServiceSearch,
      selectedRecurringServiceId,
      newRecurringServiceClick,
      showRecurringServiceEditorDialog,
      recurringServiceEditorCloseEvent,
      recurringServiceEditorUpdateEvent,
      editRecurringServiceEvent
    }
  }
}
</script>

<style lang="scss" scoped></style>
